import Axios, { AxiosInstance } from 'axios';
import Vue from "vue";
import { get as getCookie } from 'es-cookie';
import { CMError } from '@/models/cm-error.model';

declare module "vue/types/options" {
    interface ComponentOptions<V extends Vue> {
        HackathonAPI?: HackathonAPI;
    }
}

declare module "vue/types/vue" {
    interface Vue {
        $hackathonApi: HackathonAPI;
    }
}

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.HackathonAPI) this.$hackathonApi = options.HackathonAPI;
        else if (options.parent && options.parent.$hackathonApi)
            this.$hackathonApi = options.parent.$hackathonApi;
    }
});

export function makeHackathonAPI(token: string, conf: any) {
    return new HackathonAPI(token, conf);
}


export class HackathonAPI {

    private __ax: AxiosInstance | null;
    private _conf: any;
    private _token: string;

    constructor(token: string, conf: any) {
        this.__ax = null;
        this._conf = conf;
        this._token = token;
    }

    public async getHackathons() {
        try {
            const res = await this._ax.get("/me/hackathons");
            return res.data;
        } catch (error) {
            return this._handleError(error)
        }
    }

    private get _ax(): AxiosInstance {
        if (this.__ax === null) {
            this.__ax = Axios.create({
                baseURL:
                    process.env.VUE_APP_HACKATHON_API_ENDPOINT ||
                    "https://api.codemotion.com/hkt/api/",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + this._token
                }
            });
        }
        return this.__ax;
    }


    private _handleError(error: any) {
        if (error.response) {
            let errMess = this._extractError(error.response.data);
            console.error(errMess);
            if (error.response.status === 401) {
                throw new CMError(
                    "UnauthorizedRedirect",
                    errMess
                );
            }
            if (this._checkTokenDelete(error.response.data.errors)) {
                console.error("Invalid or expired token");
                throw new CMError("Unauthorized", "Invalid or expired token");
            }
            throw new CMError("CMServerError", errMess);
        } else if (error.request) {
            console.error("Error on request => Server does not respond");
            throw new Error("Error on request => Server does not respond");
        } else {
            console.error("Client error => " + error.message);
            throw new Error("Client error => " + error.message);
        }
    }

    private _checkTokenDelete(errors: any) {
        if (!errors) {
            return false;
        }
        const tError = errors.findIndex(elem => {
            return (
                elem.name === "CMInvalidTokenError" ||
                elem.name === "CMInvalidExpiredError"
            );
        });
        return tError !== -1;
    }

    private _extractError(data: any) {
        let errMess = "";
        if (data.errors && Array.isArray(data.errors)) {
            const errMess = data.errors.reduce((errT, err) => {
                return (errT += `[${err.name}] => ${err.message};`);
            }, "");
        } else if (data.error) {
            errMess = data.error;
        } else {
            errMess = "Unknow error";
        }
        return errMess;
    }

}
